import { render, staticRenderFns } from "./bonuses-statistics.vue?vue&type=template&id=0a19dd26"
import script from "./bonuses-statistics.vue?vue&type=script&lang=js"
export * from "./bonuses-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports